module.exports = __webpack_public_path__ + "img/lake-district.2.c714f64.jpg";